import React from 'react';
import { stats } from '../data/content';
import { Reveal } from './Reveal';
import { StatNumber } from './StatNumber';
export function StatsBar() {
  return <section className="relative w-full overflow-hidden bg-ink py-16 sm:py-20" data-id="element-211" data-mp="1t8dpg2onwiee">
      <div className="bg-court-dark absolute inset-0" aria-hidden="true" data-id="element-212" data-mp="1o9u4a4hw7an3" />
      <div className="relative mx-auto max-w-6xl px-5" data-id="element-213" data-mp="1jb92w1qwmkx2">
        <Reveal data-id="element-214" data-mp="1ed7jtgthalll">
          <h2 className="text-center font-display text-2xl tracking-[0.02em] text-white sm:text-3xl" data-id="element-215" data-mp="1ecz9nwoqpue3">
            I numeri <span className="text-volt" data-id="element-216" data-mp="19m90s9h3v9en">non mentono</span>
          </h2>
        </Reveal>

        <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-4 md:gap-y-0" data-id="element-217" data-mp="15ke119etp42z">
          {stats.map((stat, index) => <Reveal key={stat.label} delay={index * 0.05} className={`text-center ${index > 0 ? 'md:border-l md:border-white/15' : ''}`} data-id="element-218" data-mp="10mvrbgszektx" data-mpi={index}>
              <dt className="sr-only" data-id="element-219" data-mp="vou6orfwqdgc">{stat.label}</dt>
              <dd data-id="element-220" data-mp="qndavaca5h6m">
                <StatNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} className="block font-display text-[2.7rem] leading-none text-volt sm:text-6xl" data-id="element-221" data-mp="qo6isemz6cqc" />
                <span className="mx-auto mt-4 block max-w-[13rem] text-sm font-semibold leading-snug text-white/70" data-id="element-222" data-mp="3tf2erd45kslo">
                  {stat.label}
                </span>
              </dd>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}